
(function () {
  var sections = [];
  var ticking = false;
  var rebuildTimer = null;
  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function shouldReduceMotion() {
    return !!(prefersReducedMotion && prefersReducedMotion.matches);
  }

  function buildLine() {
    var line = document.createElement('span');
    line.className = 'cd-dark-line';
    line.setAttribute('aria-hidden', 'true');
    return line;
  }

  function buildInner(text) {
    var inner = document.createElement('span');
    inner.className = 'cd-dark-line__text';
    inner.textContent = text;
    return inner;
  }

  function splitRenderedLines(node, text) {
    var words = text.split(/\s+/).filter(Boolean);
    if (!words.length) return text ? [text] : [];

    node.textContent = '';

    var spans = words.map(function (word, index) {
      var span = document.createElement('span');
      span.textContent = index === words.length - 1 ? word : word + ' ';
      span.style.display = 'inline-block';
      span.style.whiteSpace = 'pre';
      node.appendChild(span);
      return span;
    });

    var lines = [];
    var current = [];
    var currentTop = null;

    spans.forEach(function (span) {
      var top = span.offsetTop;
      if (currentTop === null) currentTop = top;
      if (Math.abs(top - currentTop) > 2 && current.length) {
        lines.push(current.join('').trim());
        current = [];
        currentTop = top;
      }
      current.push(span.textContent || '');
    });

    if (current.length) lines.push(current.join('').trim());
    node.textContent = '';
    return lines.length ? lines : [text];
  }

  function buildLineflow(root) {
    if (!root) return;

    root.querySelectorAll('[data-cd-dark-lineflow]').forEach(function (node) {
      var original = node.getAttribute('data-cd-dark-original');
      if (!original) {
        original = (node.innerHTML || '').trim();
        node.setAttribute('data-cd-dark-original', original);
      }

      var segments = original
        .replace(/<br\s*\/?>/gi, '\n')
        .split('\n')
        .map(function (part) {
          return part.replace(/<[^>]+>/g, '').replace(/\s+/g, ' ').trim();
        })
        .filter(Boolean);

      if (!segments.length) {
        segments = [(node.textContent || '').replace(/\s+/g, ' ').trim()];
      }

      node.setAttribute('aria-label', segments.join(' '));
      node.innerHTML = '';

      var lineIndex = 0;
      segments.forEach(function (segment) {
        splitRenderedLines(node, segment).forEach(function (lineText) {
          var line = buildLine();
          line.style.setProperty('--cd-dark-line-index', String(lineIndex));
          line.appendChild(buildInner(lineText));
          node.appendChild(line);
          lineIndex += 1;
        });
      });
    });
  }

  function markVisible(node) {
    if (!node) return;
    node.classList.add('is-visible');
  }

  function getOrCreateSection(section) {
    for (var i = 0; i < sections.length; i += 1) {
      if (sections[i].root === section) return sections[i];
    }

    var entry = {
      root: section,
      content: section.querySelector('[data-cd-dark-intro-content]'),
      shopReveals: Array.prototype.slice.call(section.querySelectorAll('[data-cd-dark-shop-reveal]')),
      start: parseFloat(section.getAttribute('data-cd-reveal-start') || '0.18'),
      end: parseFloat(section.getAttribute('data-cd-reveal-end') || '0.96'),
      headerThreshold: parseFloat(section.getAttribute('data-cd-reveal-header-threshold') || '0.90'),
      lastHeaderScheme: null
    };

    buildLineflow(section);
    sections.push(entry);
    return entry;
  }

  function getNumberCssVar(node, property) {
    if (!node || !window.getComputedStyle) return 0;

    var parsed = parseFloat(
      window.getComputedStyle(node).getPropertyValue(property)
    );

    return Number.isNaN(parsed) ? 0 : parsed;
  }

  function isRevealTouchingHeader(entry) {
    if (!entry || !entry.root || !window.getComputedStyle) return false;

    var header = document.querySelector('[data-cd-hero-header]');
    if (!header) return false;

    var headerRect = header.getBoundingClientRect();
    if (headerRect.bottom <= 0) return false;

    var progress = getNumberCssVar(entry.root, '--cd-dark-reveal-progress');
    var ry = getNumberCssVar(entry.root, '--cd-dark-reveal-ry');
    if (progress <= 0.01 || ry <= 0) return false;

    var sticky = entry.root.querySelector('.cd-home-dark-intro__sticky') || entry.root;
    var rect = sticky.getBoundingClientRect();
    var viewport = Math.max(window.innerHeight || 0, 1);

    if (rect.bottom <= 0 || rect.top >= viewport) return false;

    var centerY = rect.top + rect.height * 0.5;
    var ovalTop = centerY - ry;
    var ovalBottom = centerY + ry;

    return ovalTop <= headerRect.bottom + 1 && ovalBottom >= headerRect.top;
  }

  function setHeaderScheme(entry, revealProgress) {
    if (!entry || !entry.root) return;

    var scheme =
      revealProgress >= entry.headerThreshold || isRevealTouchingHeader(entry)
        ? 'dark'
        : 'light';
    if (scheme === entry.lastHeaderScheme) return;

    entry.lastHeaderScheme = scheme;
    entry.root.setAttribute('data-cd-header-scheme', scheme);
    entry.root.setAttribute('data-cd-header-scheme-mobile', scheme);

    if (
      window.CDCleerHeaderTheme &&
      typeof window.CDCleerHeaderTheme.refresh === 'function'
    ) {
      window.CDCleerHeaderTheme.refresh();
    }
  }

  function getRevealSizes() {
    var width = window.innerWidth;
    var height = window.innerHeight;
    var isMobile = width <= 1024;
    var maxRadius = Math.sqrt(width * width + height * height) * 1.1;

    return {
      baseRx: isMobile ? Math.min(width, height) * 0.34 : Math.min(width, height) * 0.15,
      baseRy: isMobile ? Math.min(width, height) * 0.48 : Math.min(width, height) * 0.24,
      maxRx: maxRadius,
      maxRy: maxRadius
    };
  }

  function updateShopReveals(entry, revealProgress) {
    if (!entry || !entry.shopReveals) return;

    if (shouldReduceMotion()) {
      entry.shopReveals.forEach(markVisible);
      return;
    }

    entry.shopReveals.forEach(function (node) {
      var step = parseFloat(node.getAttribute('data-cd-dark-shop-reveal-step') || '0');
      var threshold = 0.08 + (step * 0.07);
      if (revealProgress >= threshold) {
        markVisible(node);
      }
    });
  }

  function updateEntry(entry) {
    if (!entry || !entry.root) return;

    if (shouldReduceMotion()) {
      entry.root.classList.add('is-inview', 'is-revealing');
      entry.root.style.setProperty('--cd-dark-reveal-progress', '1');
      entry.root.setAttribute('data-cd-dark-reveal-progress', '1');
      entry.root.style.setProperty('--cd-dark-reveal-rx', '200vmax');
      entry.root.style.setProperty('--cd-dark-reveal-ry', '200vmax');
      if (entry.content) markVisible(entry.content);
      updateShopReveals(entry, 1);
      setHeaderScheme(entry, 1);
      if (window.CDCleerSurfaceBlend && typeof window.CDCleerSurfaceBlend.update === 'function') {
        window.CDCleerSurfaceBlend.update();
      }
      return;
    }

    var rect = entry.root.getBoundingClientRect();
    var viewportHeight = window.innerHeight;
    var travel = Math.max(entry.root.offsetHeight - viewportHeight, 1);
    var overallProgress = clamp((-rect.top) / travel, 0, 1);
    var revealProgress = clamp(
      (overallProgress - entry.start) / Math.max(entry.end - entry.start, 0.01),
      0,
      1
    );
    var sizes = getRevealSizes();
    var introPhaseEnd = 0.18;
    var rx = 0;
    var ry = 0;

    if (revealProgress > 0 && revealProgress < introPhaseEnd) {
      var introProgress = easeInOutCubic(revealProgress / introPhaseEnd);
      rx = sizes.baseRx * introProgress;
      ry = sizes.baseRy * introProgress;
    } else if (revealProgress >= introPhaseEnd) {
      var expandProgress = easeInOutCubic((revealProgress - introPhaseEnd) / (1 - introPhaseEnd));
      rx = sizes.baseRx + (sizes.maxRx - sizes.baseRx) * expandProgress;
      ry = sizes.baseRy + (sizes.maxRy - sizes.baseRy) * expandProgress;
    }

    if (rect.top < viewportHeight * 0.86 && rect.bottom > viewportHeight * 0.18) {
      entry.root.classList.add('is-inview');
      if (entry.content) markVisible(entry.content);
    }

    if (revealProgress > 0) {
      entry.root.classList.add('is-revealing');
    } else {
      entry.root.classList.remove('is-revealing');
    }

    entry.root.style.setProperty('--cd-dark-reveal-progress', revealProgress.toFixed(4));
    entry.root.setAttribute('data-cd-dark-reveal-progress', revealProgress.toFixed(4));
    entry.root.style.setProperty('--cd-dark-reveal-rx', rx.toFixed(2) + 'px');
    entry.root.style.setProperty('--cd-dark-reveal-ry', ry.toFixed(2) + 'px');

    updateShopReveals(entry, revealProgress);
    setHeaderScheme(entry, revealProgress);

    if (window.CDCleerSurfaceBlend && typeof window.CDCleerSurfaceBlend.update === 'function') {
      window.CDCleerSurfaceBlend.update();
    }
  }

  function updateAll() {
    sections.forEach(updateEntry);
    ticking = false;
  }

  function queueUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateAll);
  }

  function initAll(context) {
    var scope = context || document;
    var nodes = scope.querySelectorAll('[data-cd-dark-reveal]');
    nodes.forEach(getOrCreateSection);
    queueUpdate();
  }

  function rebuildAll() {
    sections.forEach(function (entry) {
      if (!entry || !entry.root) return;
      buildLineflow(entry.root);
    });
    queueUpdate();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  window.addEventListener('load', function () {
    initAll(document);
    rebuildAll();
  });

  window.addEventListener('scroll', queueUpdate, { passive: true });
  window.addEventListener('resize', function () {
    clearTimeout(rebuildTimer);
    rebuildTimer = window.setTimeout(rebuildAll, 140);
    queueUpdate();
  });
  window.addEventListener('orientationchange', function () {
    clearTimeout(rebuildTimer);
    rebuildTimer = window.setTimeout(rebuildAll, 140);
    queueUpdate();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target || document);
    rebuildAll();
  });

  if (
    prefersReducedMotion &&
    typeof prefersReducedMotion.addEventListener === 'function'
  ) {
    prefersReducedMotion.addEventListener('change', function () {
      rebuildAll();
    });
  }

  window.CDDarkIntro = {
    initAll: initAll,
    rebuild: rebuildAll
  };
})();
